import requestCall from "../requestCall";

import {
  CONTRA_STRATEGY_URL,
  FLEXICAP_STRATEGY_URL,
  VALUE_STRATEGY_URL,
  LARGECAP_STRATEGY_URL,
  PIPE_STRATEGY_URL,
  AIF_STRATEGY_URL,
  GET_METHOD,
  POST_METHOD,
  LEARN_MORE_CONTRA,
  LEARN_MORE_FLEXICAP,
  LEARN_MORE_PIPE,
  LEARN_MORE_LARGE_CAP,
  LEARN_MORE_VALUE,
  LEARN_MORE_ACE,
  ACE_STRATEGY_URL,
} from "../apiConstants";

export const getContraStrategyDetails = async (req) => {
  const baseData = {
    endPoint: CONTRA_STRATEGY_URL,
    method: GET_METHOD,
  };
  return requestCall(baseData, req);
};
export const getAceStrategyDetails = async (req) => {
  const baseData = {
    endPoint: ACE_STRATEGY_URL,
    method: GET_METHOD,
  };
  return requestCall(baseData, req);
};

export const getFlexicapStrategyDetails = async (req) => {
  const baseData = {
    endPoint: FLEXICAP_STRATEGY_URL,
    method: GET_METHOD,
  };
  return requestCall(baseData, req);
};

export const getValueStrategyDetails = async (req) => {
  const baseData = {
    endPoint: VALUE_STRATEGY_URL,
    method: GET_METHOD,
  };
  return requestCall(baseData, req);
};

export const getLargeCapStrategyDetails = async (req) => {
  const baseData = {
    endPoint: LARGECAP_STRATEGY_URL,
    method: GET_METHOD,
  };
  return requestCall(baseData, req);
};

export const getPipeStrategyDetails = async (req) => {
  const baseData = {
    endPoint: PIPE_STRATEGY_URL,
    method: GET_METHOD,
  };
  return requestCall(baseData, req);
};

export const getLearnMoreContra = async (req) => {
  const baseData = {
    method: GET_METHOD,
    endPoint: LEARN_MORE_CONTRA,
  };

  return requestCall(baseData, req);
};
export const getLearnMoreAce = async (req) => {
  const baseData = {
    method: GET_METHOD,
    endPoint: LEARN_MORE_ACE,
  };

  return requestCall(baseData, req);
};
export const getLearnMoreFlexicap = async (req) => {
  const baseData = {
    method: GET_METHOD,
    endPoint: LEARN_MORE_FLEXICAP,
  };

  return requestCall(baseData, req);
};
export const getLearnMorePipe = async (req) => {
  const baseData = {
    method: GET_METHOD,
    endPoint: LEARN_MORE_PIPE,
  };

  return requestCall(baseData, req);
};

export const getLearnMoreLargeCap = async (req) => {
  const baseData = {
    method: GET_METHOD,
    endPoint: LEARN_MORE_LARGE_CAP,
  };

  return requestCall(baseData, req);
};

export const getLearnMoreValue = async (req) => {
  const baseData = {
    method: GET_METHOD,
    endPoint: LEARN_MORE_VALUE,
  };

  return requestCall(baseData, req);
};
